import { render, staticRenderFns } from "./AutomationEmptyStateDisconnectedToProvider.vue?vue&type=template&id=2be219a4&"
import script from "./AutomationEmptyStateDisconnectedToProvider.vue?vue&type=script&lang=js&"
export * from "./AutomationEmptyStateDisconnectedToProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports